<fidelity-overlay-page-wrapper
    *transloco="let t"
    [headerCaption]="t('fidelity-app.account.heading')">
    <div pageContent class="flex flex-col items-center flex-grow h-full">
        <mat-card
            appearance="raised"
            class="rounded-xl shadow-lg mb-4 w-full">
            <mat-card-content class="bg-tb-primary rounded-xl text-tb-primary-contrast">
                <div class="flex flex-row items-center">
                    <mat-icon
                        class="text-tb-primary-contrast min-w-12 min-h-12"
                        svgIcon="heroicons_outline:user-circle"
                    ></mat-icon>
                    <h4 class="flex-grow ml-2 text-2xl">{{ currentUser.name }}</h4>
                </div>
                <p class="mt-2 ml-1.5">{{ currentUser.email }}</p>
            </mat-card-content>
        </mat-card>
        <tb-items-list class="w-full h-full" [items]="accountOptions" (itemClicked)="openPage($event)"></tb-items-list>
    </div>
</fidelity-overlay-page-wrapper>
